import isArray from './is-array';
/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to flatten.
 * @return {Array} Returns the new flattened array.
 * @example
 *
 * flatten([1, [2, [3, [4]], 5]]);  // => [1, 2, [3, [4]], 5]
 */
var flatten = function (arr) {
    if (!isArray(arr)) {
        return [];
    }
    var rst = [];
    for (var i = 0; i < arr.length; i++) {
        rst = rst.concat(arr[i]);
    }
    return rst;
};
export default flatten;
//# sourceMappingURL=flatten.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/flatten.js
// module id = 473
// module chunks = 3